import { maskHelper } from '../helpers/mask.helper'
import { connect } from 'react-redux'
import store from '../helpers/store'

class TripDiscountHelper {
	static getFamilyDiscount(discountParameters) {
		let busSeatsCondition = 9999
		if (discountParameters && discountParameters.isActive) {
			busSeatsCondition = discountParameters.busSeatsCondition
		}

		return busSeatsCondition
	}

	static checkAllowedBusCompanies(
		familyDiscountParameters,
		selectedBusSeatsGoing
	) {
		const allowedCompanies =
			familyDiscountParameters.allowedBusCompanys.split(',')

		let busCompany = ''

		if (selectedBusSeatsGoing && Array.isArray(selectedBusSeatsGoing)) {
			let firstBusSelected = null

			firstBusSelected = selectedBusSeatsGoing[0]
			busCompany = firstBusSelected ? firstBusSelected.busCompany : ''
		} else {
			busCompany = selectedBusSeatsGoing
		}

		return allowedCompanies.includes(busCompany)
	}

	// Espelha o NormalizeText do back (ExceptionalDiscountRoute.Matches): tira o
	// conteudo entre parenteses e os acentos, faz trim e poe em maiusculas.
	// Normalizar diferente do back fazia o texto aparecer sem o desconto aplicar.
	static normalizePlace(text) {
		if (!text) return ''
		return maskHelper.normalize(String(text).replace(/\(.*?\)/g, '')).trim()
	}

	static samePlace(registered, informed) {
		return (
			TripDiscountHelper.normalizePlace(registered) ===
			TripDiscountHelper.normalizePlace(informed)
		)
	}

	// A UF so entra na comparacao quando a rota e o trecho a trazem (formato
	// MuviHub). Sem ela (formato antigo, rota sem UF) compara so a cidade: na
	// duvida o front bloqueia o texto, em vez de mostrar um desconto que o back
	// nao aplica.
	static sameState(registered, informed) {
		return (
			!registered ||
			!informed ||
			TripDiscountHelper.samePlace(registered, informed)
		)
	}

	static checkInvalidRoutes(origin, destination, originState, destinationState) {
		if (!origin || !destination) {
			return false
		}
		let blockedTrips = store.getState().site.invalidDiscountRoutes
		const { samePlace, sameState } = TripDiscountHelper

		let tripFounded = blockedTrips.find(
			(trip) =>
				(samePlace(trip.originCity, origin) &&
					sameState(trip.originState, originState) &&
					samePlace(trip.destinationCity, destination) &&
					sameState(trip.destinationState, destinationState)) ||
				(samePlace(trip.originCity, destination) &&
					sameState(trip.originState, destinationState) &&
					samePlace(trip.destinationCity, origin) &&
					sameState(trip.destinationState, originState))
		)

		return !!tripFounded
	}

	// Bug 7993: no fluxo MuviHub o trip vem com origin/destination aninhados
	// (cityName); origem/destino so existem no formato antigo do legado.
	static getTripCities(trip) {
		if (!trip) return {}
		return {
			origin: trip.origem || (trip.origin && trip.origin.cityName),
			destination:
				trip.destino || (trip.destination && trip.destination.cityName),
			originState: trip.origin && trip.origin.stateCode,
			destinationState: trip.destination && trip.destination.stateCode,
		}
	}

	// O trecho (ida e, se houver, volta) pode receber o desconto familia? Sem
	// origem/destino conhecidos nao libera: o checkInvalidRoutes trata ausente
	// como "trecho liberado".
	static isFamilyDiscountRouteAllowed(tripGoing, tripReturn) {
		const trips = tripReturn ? [tripGoing, tripReturn] : [tripGoing]

		return trips.every((trip) => {
			const { origin, destination, originState, destinationState } =
				TripDiscountHelper.getTripCities(trip)
			return (
				!!origin &&
				!!destination &&
				!TripDiscountHelper.checkInvalidRoutes(
					origin,
					destination,
					originState,
					destinationState
				)
			)
		})
	}

	// Valor que a flag familyDiscountAllowed deve ter na selecao de poltrona.
	// Funcao pura: o componente so despacha quando difere do valor atual, nos
	// dois sentidos (liga e desliga).
	static shouldAllowFamilyDiscount({
		familyDiscountParameters,
		busCompany,
		tripGoing,
		tripReturn,
		onlyMoneyOnPriceOption,
		user,
	}) {
		if (!familyDiscountParameters || !familyDiscountParameters.isActive) {
			return false
		}

		return !!(
			onlyMoneyOnPriceOption &&
			TripDiscountHelper.checkAllowedBusCompanies(
				familyDiscountParameters,
				busCompany
			) &&
			TripDiscountHelper.isFamilyDiscountRouteAllowed(tripGoing, tripReturn) &&
			!(user && user.hasPublicBody) &&
			!(user && user.isRequester)
		)
	}
}

export default TripDiscountHelper
